// extracted by mini-css-extract-plugin
export var chip = "_3g-9";
export var chipLabel = "_3g-a";
export var close = "_3g-7";
export var closeIcon = "_3g-8";
export var error = "_3g-6";
export var infoTooltip = "_3g-2";
export var innerContainer = "_3g-1";
export var input = "_3g-b";
export var medium = "_3g-5";
export var outerContainer = "_3g-0";
export var small = "_3g-4";
export var xSmall = "_3g-3";